import {
  IonContent,
  IonPage,
  IonToolbar,
  IonTitle,
} from '@ionic/react';
import { AppSectionHeader } from '../../components/ui/AppSectionHeader';
import { LeagueSearchContent } from '../components/LeagueSearchContent';

export const SearchTab = () => (
  <IonPage>
    <AppSectionHeader variant="main">
      <IonToolbar>
        <IonTitle className="ml-4">Buscar</IonTitle>
      </IonToolbar>
    </AppSectionHeader>
    <IonContent className="ion-padding">
      <LeagueSearchContent />
    </IonContent>
  </IonPage>
);
